import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PushPipe } from '@ngrx/component';
import { ITenant, SystemDataService } from '@wdx/kamino/api-service';
import { WdxDropdownModule } from '@wdx/shared/components/wdx-dropdown';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';

@Component({
    selector: 'kmo-tenant',
    imports: [
        WdxDropdownModule,
        WdxIconModule,
        NgbDropdownModule,
        NgSelectModule,
        FormsModule,
        PushPipe,
    ],
    templateUrl: './tenant.component.html',
    styleUrls: ['./tenant.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KaminoTenantComponent {
    @Input() tenants: ITenant[] | undefined = [];

    @Output() tenantSwitch = new EventEmitter<ITenant>();

    private systemDataService = inject(SystemDataService);

    selectedTenant$ = this.systemDataService.tenant$;

    onTenantChange(tenantCode: string): void {
        const tenant = this.tenants?.find(
            (currentTenant) => currentTenant.code === tenantCode,
        );

        if (!tenant) {
            return;
        }

        this.switchTenant(tenant);
    }

    switchTenant(tenant: ITenant): void {
        this.systemDataService.setTenantData(tenant?.code);
        this.tenantSwitch.emit(tenant);
    }
}
